export default {
      id: "fleche_date_agenda-usage",
      viewBox: "0 0 18 11",
      url: "../dist/images/" + "sprite.svg#fleche_date_agenda-usage",
      toString: function () {
        return this.url;
      }
    }